/**
 * hay.ts - the in-table search matcher for the browse-all Lookup tables (Portal hayIncludes clone).
 *
 * Token-AND (Alignment feedback 2026-08): every whitespace-separated word of the query must appear
 * somewhere in the hay, so "daniel thomas" matches DANIEL B THOMAS and "sarah warnock" matches
 * SARAH C WARNOCK without the middle initial. A single-word query keeps the original substring
 * semantics exactly, and a contiguous multi-word match still passes (each of its words is then a
 * substring on its own) - the widening is strict.
 *
 * Hay strings carry the stripped member_id join key, but operators may paste the padded 11-digit
 * display form: an all-digit token with leading zeros retries with the zeros stripped.
 */
export function hayIncludes(hay: string, query: string): boolean {
  const tokens = query.split(/\s+/).filter(Boolean);
  if (!tokens.length) return true; // whitespace-only query filters nothing (callers guard '' already)
  return tokens.every((t) => tokenInHay(hay, t));
}

function tokenInHay(hay: string, token: string): boolean {
  if (hay.includes(token)) return true;
  if (!/^0\d+$/.test(token)) return false;
  const stripped = token.replace(/^0+/, '');
  return stripped !== '' && hay.includes(stripped);
}
